import handleResult from '../common/handleResult';
import requestJs from '../common/request';
import serviceConfig from '../api/serviceConfig';

//根据token获取登录用户信息
export const getLoginUserInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.personalInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};
// 敏感词校验
export const recognizeText = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.recognizeText,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};



// WEBPACK FOOTER //
// ./src/api/user.js